export default __webpack_public_path__ + "static/media/booking-slide3-bg.e58ca0a1.png";